import Icon from '../components/Icon.vue'

Icon.register({
  'heart-broken': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M473.7 73.8L471.3 71.3C425.3 24.3 353.3 19.6 301.7 56.5L336 159.9 240 223.9 288 351.9 144 207.9 240 143.9 211.4 57.4C159.7 19.6 87 24 40.7 71.4L38.3 73.8C-10.4 123.6-12.5 202.9 31 256L243.1 474.6C250.2 481.9 261.7 481.9 268.8 474.6L481 255.9C524.5 202.9 522.4 123.6 473.7 73.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/heart-broken.js
// module id = PTwX
// module chunks = 144